import React from 'react'
import { createPortal } from 'react-dom'

import {
  Button,
  Flex 
} from '@driftt/dds'
import {
  Footer,
  H2,
  Modal,
  P 
} from '@driftt/tide-core'

const ArchiveConfirmationModal = ({
  attributeToUpdate,
  desiredAttributeStatus,
  onArchive,
  onCancel 
}) => {
  return createPortal(<Modal
    className="contact-attribute-archive-confirmation-modal"
    open={ true }
    onClose={ onCancel }
    size="small">
    <H2>Are you sure you want to archive {attributeToUpdate.name}?</H2>
    <P>Once archived, you will no longer be able to add this attribute to routing or 
        segment settings in Drift. Existing usage of this attribute will continue to work.
    </P>
    <P>You will be able to unarchive this attribute.</P>
    <Footer>
      <Flex>
        <Button onClick={() => onArchive(attributeToUpdate, desiredAttributeStatus)}>
            Archive
        </Button>
        <Button variant="secondary" onClick={onCancel}>
            Cancel
        </Button>
      </Flex>
        
    </Footer>
  </Modal>, document.body)
}

export default ArchiveConfirmationModal
